import axios from "axios";
const cors = require('cors');



export function  faqPageData(){

    return new Promise((resolve,reject)=>{
        axios.get('https://blcadmin.brac.net/api/blc-faq',cors()).then(response=>{

            resolve(response);
        });
    });
}


// http://localhost:1337/blc-pricing
//http://34.123.182.161/blc-faqs
//https://blcadmin.brac.net/blc-faqs